import axiosVerbose from './axios/axiosVerbose'

/**
 * Get shopfront jwt token with given sso token
 * @return {String} jwt token
 */
export const getSession = () => axiosVerbose.get('/jwt_session')

export const createSession = (token: string) =>
  axiosVerbose.post('/jwt_session', { token })
